/**
 * Enum for controlling automatic content generation behavior when opening editors
 */
export enum AutomaticContentGeneration {
	/** Do nothing - just open the editor normally */
	DoNothing = 'DoNothing',
	
	/** Open the editor and show the generation settings modal */
	OpenSettings = 'OpenSettings',
	
	/** Open the editor and generate content with default settings */
	GenerateWithDefaultSettings = 'GenerateWithDefaultSettings',
	
	/** Generate content in background with default settings without opening editor */
	GenerateInBackgroundWithDefaultSettings = 'GenerateInBackgroundWithDefaultSettings'
}